import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class ProjectHeader extends React.Component {
  render() {
    let data    = this.props.data;
    let project = data.project || {};
    let event   = data.event || {};

    return (
      <div className="project-header">
        <div className="project-title">
          <a href="/"><i className="material-icons">chevron_left</i></a>
          <p>{project.title}</p>
        </div>

        { (event.refreshProject != undefined) &&
          <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>リフレッシュ</Tooltip>}>
            <div className="refresh-box" onClick={event.refreshProject.bind(this)}>
              <i className="material-icons">refresh</i>
            </div>
          </OverlayTrigger>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectHeader;